<form #inviteForm="ngForm" autocomplete="off">
  <div class="ui-modal-header">
    <h2>{{ modalTitle }}</h2>
    <div class="ui-modal-close" (click)="dismiss()">
      <mdi name="Close"></mdi>
    </div>
  </div>

  <div class="ui-modal-body">
    <div class="suggestions-list" [ngClass]="{ 'scroll-at-top': listTopShadow, 'scroll-at-bottom': listBottomShadow }">
      <ul cdkScrollable #usersList *ngIf="users.length">
        <li *ngFor="let user of users; let i = index">
          <img
            [src]="user.imageid ? configUrl.bucketImage + user.id + '/' + user.imageid : ''"
            class="suggestions-list-profile-image"
            onError="this.src='/assets/images/profile.png';"
          />
          {{ user.name }}

          <a (click)="performAction(user)" class="action">{{ actionTitle }}</a>
        </li>
      </ul>
      <div *ngIf="!users.length" class="suggestions-list-no-results" i18n>No Users</div>
    </div>
  </div>

  <div class="ui-modal-footer"></div>
</form>
